import React from 'react';

export const Footer = () => {
  return (
    <footer>
      <p>Footer</p>
    </footer>
  );
};
